module.exports = __webpack_public_path__ + "static/media/16UNODC36.59998cd5.jpg";